module.exports = __webpack_public_path__ + "img/close.86d32b69.svg";